<template>
    <div class="m-paginationSmall align-items-center gap-0-5">
        <div
            class="m-paginationSmall__arrow d-flex"
            :class="[
                paging.prevPage && 'cursor-pointer',
                !paging.prevPage && '--disabled'
            ]"
            @click="paging.prevPage && setPagination(paging.prevPage)"
        >
            <a-icon icon="ArrowLeft" />
        </div>
        <div class="m-paginationSmall__input">
            <input
                @change="setPagination($event.target.value)"
                :value="page"
                :custom-class="'text-center'"
                class="form-control form-control-xs text-center mb-0"
                :placeholder="paging.page"
                type="number"
                min="1"
            />
        </div>
        <div class="m-paginationSmall__total">
            z
            <span
                style="cursor: pointer; padding-left: 0.25rem"
                @click="setPagination(paging.totalPages)"
            >{{ paging.totalPages }}</span>
        </div>
        <div
            class="m-paginationSmall__arrow d-flex"
            :class="[
                paging.nextPage && 'cursor-pointer',
                !paging.nextPage && '--disabled'
            ]"
            @click="paging.nextPage && setPagination(paging.nextPage)"
        >
            <a-icon icon="ArrowRight" height="24px" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ThePaginationSmall',
    props: {
        pagination: {
            type: Object,
            required: false
        },
        getter: {
            type: Object,
            required: false
        },
        setter: {
            type: String,
            required: false
        },
        setMethod: {
            type: Function,
            required: false
        },
        loader: {
            type: String,
            required: false
        },
        page: {
            type: String,
            default: ''
        }
    },
    computed: {
        paging() {
            return this.pagination || this.getter
        }
    },
    methods: {
        setPagination(page) {
            if (this.loader && this.$store.getters[this.loader] === 'loading') {
                return
            }

            if (+page > +this.paging.totalPages) {
                page = this.paging.totalPages
            }

            if (+page < 1) {
                page = 1
            }

            if (!this.setter && !this.setMethod) {
                this.$emit('change', page)
            }

            if (this.setter) {
                this.$store.dispatch(this.setter, {
                    page
                })
            } else if (this.setMethod) {
                this.setMethod(page)
            }
        }
    }
}
</script>
